import { render } from "./Department.vue?vue&type=template&id=f8f5ae72&scoped=true"
import script from "./Department.vue?vue&type=script&lang=js"
export * from "./Department.vue?vue&type=script&lang=js"

import "./Department.vue?vue&type=style&index=0&id=f8f5ae72&scoped=true&lang=css"
import "./Department.vue?vue&type=style&index=1&id=f8f5ae72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8f5ae72"]])

export default __exports__